import EmptyLayout from '@/layouts/EmptyLayout.vue';
import { ISnotrRoute } from '..';

export default [
  {
    path: '/invoices',
    name: 'Invoices',
    meta: {
      title: 'TabTitle.invoices',
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/pages/invoices.vue'),
  },
  {
    path: '/overdue-invoices',
    name: 'OverdueInvoices',
    meta: {
      title: 'TabTitle.overdueInvoices',
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/pages/overdue-invoices.vue'),
  },
  {
    path: '/customer-payment-behaviour',
    name: 'CustomerPaymentBehaviour',
    meta: {
      title: 'TabTitle.customerPaymentBehaviour',
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/pages/customer-payment-behaviour.vue'),
  },
  {
    path: '/invoices/new',
    name: 'InvoicesNew',
    meta: {
      title: 'TabTitle.newInvoice',
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/pages/invoices-new.vue'),
  },
  {
    path: '/invoices/:id',
    name: 'InvoicesShow',
    meta: {
      title: 'TabTitle.invoice',
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/pages/invoices-show.vue'),
  },
  {
    path: '/invoices/:id/pdf',
    name: 'InvoicesPdf',
    meta: {
      title: 'TabTitle.pdfInvoice',
      applicationMode: 'InvoicingMode',
      layout: EmptyLayout,
    },
    props: route => ({
      type: route.query.type || 'invoice',
      maxDate: route.query.maxDate,
    }),
    component: () => import('@/pages/invoices-pdf.vue'),
  },
] as ISnotrRoute[];
